"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var UsrPermissionsList_1 = require("./component/UsrPermissionsList");
var UsrPermissionEditor_1 = require("./component/UsrPermissionEditor");
var UsrPermissionAllowedDocsList_1 = require("./component/UsrPermissionAllowedDocsList");
var UsrPermissionsAdminsAccessList_1 = require("./component/UsrPermissionsAdminsAccessList");
var PUsrPermissionsList = /** @class */ (function (_super) {
    __extends(PUsrPermissionsList, _super);
    function PUsrPermissionsList(props) {
        return _super.call(this, props) || this;
    }
    PUsrPermissionsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                page_size: data.tablePageSize
            });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            page_num: 1,
            page_size: this.props.state.getTablePageSize()
        });
    };
    PUsrPermissionsList.prototype.componentWillUnmount = function () {
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PUsrPermissionsList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", record: null });
    };
    PUsrPermissionsList.prototype.onEditClick = function (val) {
        this.setState({ edit_mode: "EDIT", record: val });
    };
    PUsrPermissionsList.prototype.onGoToDocksListClick = function (val) {
        this.setState({ edit_mode: "DOCS-LIST", record: val });
    };
    PUsrPermissionsList.prototype.onGoToAccessConfigClick = function (val) {
        this.setState({ edit_mode: "ACCESS", record: val });
    };
    PUsrPermissionsList.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", record: null });
    };
    PUsrPermissionsList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PUsrPermissionsList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(UsrPermissionEditor_1.default, { data: this.props.data, state: this.props.state, record: null, onGoBack: this.onGoBackClick.bind(this) }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(UsrPermissionEditor_1.default, { data: this.props.data, state: this.props.state, record: this.state.record, onGoBack: this.onGoBackClick.bind(this) }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(UsrPermissionsList_1.default, { data: this.props.data, state: this.props.state, onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), onGoToDocksListClick: this.onGoToDocksListClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, onAccessConfigClick: this.onGoToAccessConfigClick.bind(this) }));
        }
        if (this.state.edit_mode === "DOCS-LIST") {
            return (React.createElement(UsrPermissionAllowedDocsList_1.default, { state: this.props.state, onGoBackClick: this.onGoBackClick.bind(this), record: this.state.record, data: this.props.dataDocuments, docAccessAvail: this.props.listPermissionDocumentCodesAvail, dlgSelectKeyValue: this.props.dlgSelectKeyValue }));
        }
        if (this.state.edit_mode === "ACCESS") {
            return (React.createElement(UsrPermissionsAdminsAccessList_1.default, { state: this.props.state, onGoBackClick: this.onGoBackClick.bind(this), record: this.state.record, dialog: this.props.dialogAdminSelect, data: this.props.dataAdminPermissions }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PUsrPermissionsList.prototype.render = function () {
        return this.getRenderObject();
    };
    PUsrPermissionsList.getPageDescription = function (state) {
        return {
            icon: "user-shield",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_usr_permissions + "-id",
            itemTitle: "Роли и права",
            route: routes_1.routes.page_usr_permissions,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PUsrPermissionsList;
}(React.Component));
exports.default = PUsrPermissionsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/usr_permissions_list/ui/PUsrPermissionsList.tsx
// module id = 1886
// module chunks = 0